import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ClipboardCheck, ChevronRight } from "lucide-react";

export default function ApprovalQueue() {
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("ALL");
  useEffect(() => { api.get("/approval-queue").then((r) => setItems(r.data)); }, []);
  const types = ["ALL", ...Array.from(new Set(items.map((i) => i.type)))];
  const shown = filter === "ALL" ? items : items.filter((i) => i.type === filter);

  return (
    <div className="space-y-6" data-testid="approval-queue-page">
      <div><h1 className="font-heading text-3xl font-bold tracking-tight">Approval Queue</h1><p className="mt-1 text-muted-foreground">All items awaiting your action. Click to open.</p></div>
      {items.length > 0 && (
        <div className="flex flex-wrap gap-2" data-testid="queue-filters">
          {types.map((t) => (
            <button key={t} onClick={() => setFilter(t)} data-testid={`queue-filter-${t.replace(/\s+/g, "-")}`}
              className={`rounded-full border px-3 py-1 text-xs font-medium ${filter === t ? "border-primary bg-primary text-primary-foreground" : "border-border text-muted-foreground hover:bg-accent"}`}>
              {t}
            </button>
          ))}
        </div>
      )}
      {items.length === 0 ? (
        <Card className="flex flex-col items-center justify-center p-12 text-muted-foreground">
          <ClipboardCheck className="h-10 w-10" /><p className="mt-2">Nothing pending. You're all caught up!</p>
        </Card>
      ) : (
        <div className="space-y-3">
          {shown.map((it, i) => (
            <Card key={i} onClick={() => nav(it.link)} className="flex cursor-pointer items-center justify-between p-4 hover:border-primary/50" data-testid={`queue-item-${i}`}>
              <div className="flex items-center gap-4">
                <Badge variant="outline" className="border-primary/30 bg-primary/10 text-primary">{it.type}</Badge>
                <div>
                  <p className="font-medium">{it.title}</p>
                  <p className="text-xs text-muted-foreground">{it.stage}</p>
                </div>
              </div>
              <ChevronRight className="h-5 w-5 text-muted-foreground" />
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
